import { render } from "./manufacturer.vue?vue&type=template&id=89eaace2&ts=true"
import script from "./manufacturer.vue?vue&type=script&lang=ts"
export * from "./manufacturer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__